import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.agent.useraccount.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_USER_ACCOUNT_ASYNC: `${uid}.saveUserAccountAsync`,
    SAVE_USER_ACCOUNT_SUCCESS: `${uid}.saveUserAccountSuccess`,
    SAVE_USER_ACCOUNT_FAILURE: `${uid}.saveUserAccountFailure`,    
    GET_ALL_COUNTRY_CODE_ASYNC:`${uid}.getAllCountryCodeAsync`,
    GET_ALL_COUNTRY_CODE_SUCCESS:`${uid}.getAllCountryCodeSuccess`,
    GET_ALL_COUNTRY_CODE_FAILURE:`${uid}.getAllCountryCodeFailure`,
};

export { ActionTypes };